import { render, staticRenderFns } from "./posterInformation.vue?vue&type=template&id=61743184&scoped=true&"
import script from "./posterInformation.vue?vue&type=script&lang=js&"
export * from "./posterInformation.vue?vue&type=script&lang=js&"
import style0 from "./posterInformation.vue?vue&type=style&index=0&id=61743184&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61743184",
  null
  
)

export default component.exports